import React from "react";
import content from 'content.json';
import { Card, CardBody, CardFooter, Row, Col } from "reactstrap";

function UserProfile() {
  return (
    <div className="content">
      <Row>
        <Col md="8">
          <Card>
            <CardBody>
              <div className="profile-card">
                <img
                  alt="Steve de Peijper"
                  className="avatar"
                  src={require("assets/img/steve.jpeg")}
                />
                <h5 className="title">Steve de Peijper</h5>
                <p className="description" style={{ marginBottom: '4px' }}>
                  Creator of <span className="gradient-text" style={{ fontWeight: 600 }}>{content.brandname}</span>
                </p>
                <p style={{ fontSize: '0.85rem', marginBottom: '24px' }}>
                  BI &amp; Analytics engineer, owner of BI2Analytics
                </p>
                
                <div style={{ 
                  background: 'rgba(255,255,255,0.03)', borderRadius: '12px', 
                  padding: '20px 24px', margin: '16px 0 24px', textAlign: 'left',
                  border: '1px solid rgba(255,255,255,0.06)'
                }}>
                  <p style={{ fontSize: '0.9rem', lineHeight: 1.8, margin: 0 }}>
                    I created IndoorAirIQ to better understand PPM levels per room during the night. 
                    I hope you enjoy using the app!
                  </p>
                </div>

                <a
                  href="https://www.linkedin.com/in/stevedep/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-airiq"
                  style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                  <i className="fab fa-linkedin" style={{ marginRight: '8px' }}></i>
                  Connect on LinkedIn
                </a>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default UserProfile;
